import { gql } from '@apollo/client';

export const INTROSPECT = gql`
  query wEcomIntrospect($token: String!, $ecomToken: String, $idToken: String) {
    wEcomIntrospect(token: $token, ecomToken: $ecomToken, idToken: $idToken)
  }
`;
